import SettingsRoutes, { SETTINGS_BASE_ROUTES } from './SettingsRoutes';

export { SettingsRoutes, SETTINGS_BASE_ROUTES };
